const BASE = (process.env.REACT_APP_API_URL || '') + '/api';

const getToken = () => localStorage.getItem('admin_token');

const req = async (method, path, body) => {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

export const adminApi = {
  // Auth
  login: (email, password) => req('POST', '/admin/login', { email, password }),

  // Stats
  getStats: () => req('GET', '/admin/stats'),

  // Users
  getUsers: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return req('GET', `/admin/users?${q}`);
  },
  getUser:      (id) => req('GET',    `/admin/users/${id}`),
  updateUser:   (id, data) => req('PUT',    `/admin/users/${id}`, data),
  deleteUser:   (id) => req('DELETE', `/admin/users/${id}`),
  bulkUsers:    (ids, action) => req('POST', '/admin/users/bulk', { ids, action }),

  // Admins
  getAdmins:    () => req('GET', '/admin/admins'),
  createAdmin:  (data) => req('POST', '/admin/admins', data),
  updateAdminRole: (id, role) => req('PUT', `/admin/admins/${id}/role`, { role }),
  removeAdmin:  (id) => req('DELETE', `/admin/admins/${id}`),

  // Templates
  getTemplates:    () => req('GET', '/admin/templates'),
  createTemplate:  (data) => req('POST', '/admin/templates', data),
  updateTemplate:  (id, data) => req('PUT', `/admin/templates/${id}`, data),
  deleteTemplate:  (id) => req('DELETE', `/admin/templates/${id}`),

  // Announcements
  getAnnouncements:    () => req('GET', '/admin/announcements'),
  createAnnouncement:  (data) => req('POST', '/admin/announcements', data),
  updateAnnouncement:  (id, data) => req('PUT', `/admin/announcements/${id}`, data),
  deleteAnnouncement:  (id) => req('DELETE', `/admin/announcements/${id}`),

  // Documents
  getDocuments: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return req('GET', `/admin/documents?${q}`);
  },

  // Section config (premium badges)
  getSectionConfig:    () => req('GET', '/admin/section-config'),
  updateSectionConfig: (premiumSections) => req('PUT', '/admin/section-config', { premiumSections }),

  // About page
  getAbout:    () => req('GET', '/about'),
  updateAbout: (data) => req('PUT', '/about', data),

  // Blog
  getAllBlogPosts:  () => req('GET', '/blog/admin/all'),
  getBlogPost:     (id) => req('GET', `/blog/admin/${id}`),
  createBlogPost:  (data) => req('POST', '/blog', data),
  updateBlogPost:  (id, data) => req('PUT', `/blog/${id}`, data),
  deleteBlogPost:  (id) => req('DELETE', `/blog/${id}`),

  // Documents (extended)
  deleteDocument:      (id) => req('DELETE', `/admin/documents/${id}`),
  searchDocuments:     (params = {}) => { const q = new URLSearchParams(params).toString(); return req('GET', `/admin/documents/search?${q}`); },

  // Platform config
  getPlatformConfig:   () => req('GET', '/admin/platform-config'),
  updatePlatformConfig:(data) => req('PUT', '/admin/platform-config', data),

  // Activity feed
  getActivity:         () => req('GET', '/admin/activity'),

  // Referrals
  getReferralStats:    () => req('GET', '/admin/referrals/stats'),
  getReferrals:        (qs = '') => req('GET', `/admin/referrals${qs}`),
  getUserReferralInfo: (userId) => req('GET', `/admin/referrals/user/${userId}`),
  adjustUserPoints:    (userId, points, reason) => req('POST', `/admin/referrals/user/${userId}/adjust`, { points, reason }),
  flagReferral:        (id, fraudFlag) => req('PUT', `/admin/referrals/${id}/flag`, { fraudFlag }),

  // Interviews
  getInterviewStats: () => req('GET', '/admin/interviews/stats'),
  getInterviews: (params = {}) => { const q = new URLSearchParams(params).toString(); return req('GET', `/admin/interviews?${q}`); },
  getInterview:  (id) => req('GET', `/admin/interviews/${id}`),
  deleteInterview: (id) => req('DELETE', `/admin/interviews/${id}`),

  // Custom Email
  getEmailRecipientCount: (audience) => req('GET', `/admin/email/recipients?audience=${audience}`),
  sendCustomEmail: (data) => req('POST', '/admin/email/send', data),

  // Feedback
  getFeedbackStats: () => req('GET', '/admin/feedback/stats'),
  getFeedback: (params = {}) => { const q = new URLSearchParams(params).toString(); return req('GET', `/admin/feedback?${q}`); },
  updateFeedback: (id, data) => req('PUT', `/admin/feedback/${id}`, data),
  deleteFeedback: (id) => req('DELETE', `/admin/feedback/${id}`),
};
